import { getPrice } from '@fourthwall/utils'

export const formatMoney = (value?: number, currency?: string) =>
  value ? getPrice(value, { currency }) : ''
